import { render } from "./ItemList.vue?vue&type=template&id=2204e05c&scoped=true"
import script from "./ItemList.vue?vue&type=script&lang=js"
export * from "./ItemList.vue?vue&type=script&lang=js"

import "./ItemList.vue?vue&type=style&index=0&id=2204e05c&lang=scss&scoped=true"

import exportComponent from "/proyectos/programas-de-investigacion/cah-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2204e05c"]])

export default __exports__